import { Theme } from "@radix-ui/themes";
import { ErrorBoundary as RollbarErrorBoundary, Provider as RollbarProvider } from "@rollbar/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import App from "./App";
import "./i18n";
import ErrorPage from "./pages/ErrorPage";
import "./styles/main.css";
import { rollbarConfig } from "./utils/rollbarConfig";

const container = document.getElementById("root")!;
const root = createRoot(container);

posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_API,
    ui_host: import.meta.env.VITE_POSTHOG_UI,
    defaults: "2026-01-30",
    autocapture: false,
    capture_pageview: "history_change",
    disable_session_recording: true,
    capture_exceptions: false,
    cookieless_mode: "always",
});

root.render(
    <StrictMode>
        <RollbarProvider config={rollbarConfig}>
            <RollbarErrorBoundary
                fallbackUI={() => (
                    <ErrorPage
                        title="We encountered an issue"
                        description="We're sorry for the inconvenience. We've reported this to our analytics. In the meantime please try contacting support."
                        hideNextSteps={false}
                    />
                )}
            >
                <PostHogProvider client={posthog}>
                    <BrowserRouter>
                        <Theme>
                            <App />
                        </Theme>
                    </BrowserRouter>
                </PostHogProvider>
            </RollbarErrorBoundary>
        </RollbarProvider>
    </StrictMode>,
);
